<template>
	<div class='add-address-block'>

		<button @click='addAddress'>Добавить в список</button>

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'AddAddressBlock',
		computed: {
			stateAddress() {
				return this.$store.state.createLpo.address;
			},

			selectedSection: {
				get() {
					return this.stateAddress.selectedSection;
				},
				set(value) {
					this.selectSection(value);
				}
			},

			sectionLpExists: {
				get() {
					return this.stateAddress.sectionLpExists;
				},
				set(value) {
					this.setSectionLpExists(value);
				}
			},
			selectedSectionLp: {
				get() {
					return this.stateAddress.selectedSectionLp;
				},
				set(value) {
					this.selectSectionLp(value);
				}
			},

			...mapState('createLpo', {
				multipleList: state => state.multipleList,
			}),

			...mapState('createLpo/address', {
				selectedLocalforestry: state => state.selectedLocalforestry,

				selectedSection: state => state.selectedSection,
				sectionLpExists: state => state.sectionLpExists,
				selectedSectionLp: state => state.selectedSectionLp,
			})
		},
		methods: {
			addAddress() {
				if (!this.checkAddress()) {
					return;
				}

				this.addAddressToMultipleList();
			},

			checkAddress() {
				const completeness = this.checkAddressCompleteness();

				switch (completeness) {
					case -1:
						this.$toast.add({severity: 'warn', detail: 'Нужно полностью указать адрес', life: 10000});
						return false;
					case -2:
						this.$toast.add({severity: 'warn', detail: 'Нужно указать лп выдел', life: 10000});
						return false;
				}

				const uniqueness = this.checkAddressUniqueness();
				if (!uniqueness) {
					this.$toast.add({severity: 'warn', detail: 'Адрес уже добавлен в список', life: 10000});
					return false;
				}

				const location = this.checkAddressLocation();
				if (!location) {
					this.$toast.add({severity: 'warn', detail: 'Обследования не могу быть в разных лесничествах', life: 10000});
					return false;
				}

				return true;
			},

			checkAddressCompleteness() {
				const ERROR_NO_SECTION = -1;
				const ERROR_NO_SECTION_LP = -2;
				const SUCCESS = 0;

				if (!this.selectedSection) {
					return ERROR_NO_SECTION;

				} else if (this.sectionLpExists && this.selectedSectionLp === null) {
					return ERROR_NO_SECTION_LP;
				}

				return SUCCESS;
			},

			checkAddressUniqueness() {
				const section = this.selectedSection;
				const sectionLp = this.selectedSectionLp;

				const exists = this.multipleList.find(item => {
					return (item.tax_id === section.id) && (item.section_lp === sectionLp);
				});

				this.$emit('not-uniq-error', exists);

				if (exists) {
					return false;
				}

				return true;
			},

			checkAddressLocation() {
				if (!this.multipleList.length) {
					return true;
				}

				const address = this.multipleList[0];
				if (address.localforestry_id !== this.selectedLocalforestry.id) {
					return false;
				}

				return true;
			},

			...mapActions('createLpo', [
				'addAddressToMultipleList'
			])
		}

	};
</script>

<style scoped>
</style>